import { render, staticRenderFns } from "./NewScenario.vue?vue&type=template&id=55154501&"
import script from "./NewScenario.vue?vue&type=script&lang=js&"
export * from "./NewScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports